import React from 'react';
export var MoreMessagesBanner = function MoreMessagesBanner(props) {
  var title;
  var subtitle;

  if (props.loading) {
    title = 'Loading More Messages';
    subtitle = 'Please wait while we load more messages...';
  } else {
    if (props.hasMore) {
      title = 'Load More Messages';
      subtitle = 'Scroll to the top to load more messages...';
    } else {
      title = null;
      subtitle = 'There are no more messages to load, you are at the beginning.';
    }
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "banner banner--more"
  }, /*#__PURE__*/React.createElement("div", {
    className: "banner__title"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "banner__subtitle"
  }, subtitle));
};